import axios from "axios";
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import SubmitButton from "../../../components/SubmitButton";
import { IoIosInformationCircle } from "react-icons/io";
import { MdOutlineVisibilityOff } from "react-icons/md";
import { MdOutlineVisibility } from "react-icons/md";

const customStyles = {
  content: {
    display: "flex",
    alignItems: "flexStart",
    justifyContent: "center",
    // width: "350px",
    width: "400px",
    minHeight: "23em",
    // background: "lightBlue",
    overflowY: "hidden",
    boxShadow: "0px 10px 8px rgba(0,0,0,0.2)",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    padding: "0",
    paddingBottom: "10px",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
  },
};

const AddEmployerModal = ({
  manageUserModalOpen,
  handlemanageUserClose,
  fetchConsoleUsers,
  setError,
}) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: { Authorization: `${token}` },
  };

  const [userType, setUserType] = useState("");
  const [userName, setUserName] = useState("");
  const [userMail, setUserMail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userPasswordConfirm, setUserPasswordConfirm] = useState("");

  const [userPasswordShow, setUserPasswordShow] = useState(false);
  const [userPasswordConfirmShow, setUserPasswordConfirmShow] = useState(false);

  const [isDiabledUser, setIsDiabledUser] = useState(true);
  const [responseMsgUser, setResponseMsgUser] = useState("");

  const [hasNoEmail, setHasNoEmail] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const [passwordEmpty, setPasswordEmpty] = useState(false);
  const [confirmEmpty, setConfirmEmpty] = useState(false);
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const [userTypeError, setUserTypeError] = useState(false);
  const [validPassword, setValidPassword] = useState(false);

  const resetError = () => {
    setPasswordEmpty(false);
    setHasNoEmail(false);
    setInvalidEmail(false);
    setConfirmEmpty(false);
    setPasswordMatchError(false);
    setValidPassword(false);
    setUserTypeError(false);
  };

  useEffect(() => {
    if (
      userType &&
      userMail &&
      userPassword &&
      userPasswordConfirm &&
      userPassword === userPasswordConfirm
    ) {
      setIsDiabledUser(false);
    } else setIsDiabledUser(true);
  }, [userType, userName, userMail, userPassword, userPasswordConfirm]);

  const handleUserClick = (e) => {
    e.preventDefault();
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const passwordRegex =
      /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]).{8,}$/;
    if (!userType) {
      setUserTypeError(true);
      return;
    } else setUserTypeError(false);
    if (!userMail) {
      setHasNoEmail(true);
      return;
    } else setHasNoEmail(false);
    if (!userPassword) {
      setPasswordEmpty(true);
      return;
    } else setPasswordEmpty(false);
    if (!userPasswordConfirm) {
      setConfirmEmpty(true);
      return;
    } else setConfirmEmpty(false);
    if (!emailRegex.test(userMail)) {
      setInvalidEmail(true);
      return;
    } else {
      setInvalidEmail(false);
    }
    if (!passwordRegex.test(userPassword)) {
      setValidPassword(true);
      return;
    } else {
      setValidPassword(false);
    }

    if (userPassword !== userPasswordConfirm) {
      setPasswordMatchError(true);
      return;
    } else setPasswordMatchError(false);
    const lender_id = localStorage.getItem("lender_id");
    axios
      .post(
        `${process.env.REACT_APP_URL}/lender/console_user`,
        {
          email: userMail.toLowerCase(),
          password: userPassword,
          lender_type: Number(userType),
          lender_id: lender_id,
        },
        config
      )
      .then((response) => {
        handlemanageUserClose();
        fetchConsoleUsers();
        setUserType("");
        setUserName("");
        setUserMail("");
        setUserPassword("");
        setUserPasswordConfirm("");
        setResponseMsgUser("");
        console.log(response.data);
        if (response.data.error) {
          setError(response.data.error);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const BoldSpan = (props) => {
    return <span className="font-bold">{props.children}</span>;
  };

  return (
    <Modal isOpen={manageUserModalOpen} style={customStyles}>
      <div className="addEmployer-container">
        <form>
          <h1>Add New User</h1>
          <div className="password-input-container">
            <div className="password-input-div ">
              <select
                onChange={(e) => {
                  setUserType(e.target.value);
                  setUserTypeError(false);
                }}
                className="pr-1"
                required
              >
                <option value="" disabled selected>
                  Select User Type
                </option>
                <option value="0">Admin</option>
                <option value="1">Relation Manager</option>
              </select>
            </div>
            {userTypeError && (
              <div className="text-red-400 space-x-1  flex  items-center ">
                <IoIosInformationCircle />{" "}
                <span className="text-xs">Please select a user type</span>
              </div>
            )}
            {/* <div className="password-input-div">
                            <input
                                type="text"
                                placeholder="User Name"
                                onChange={(e) => setUserName(e.target.value)}
                                value={userName}
                                required
                            />
                        </div> */}
            {/* <div
              // style={{ outlineColor: "#d1d5db" }}
              // className={`mt-[0.29rem] shadow mb-4 ml-[0.2rem] mr-[0.2rem] font-normal rounded   w-full border-style h-10 pt-0 pb-0 pl-4 pr-4 outline-1 outline ${
              //   hasNoEmail || invalidEmail
              //     ? "outline-1 outline outline-red-400"
              //     : ""
              // }`}
            > */}
            <div
              // style={{ outlineColor: "#d1d5db" }}
              className={` border-style shadow  rounded  flex items-center h-10  mb-2 font-medium outline-1 outline  w-full mt-2  ${
                hasNoEmail || invalidEmail
                  ? " outline-red-400"
                  : "outline-[#d1d5db]"
              }`}
            >
              <input
                type=""
                placeholder="User email"
                onChange={(e) => {
                  setUserMail(e.target.value);
                  setInvalidEmail(false);
                  setHasNoEmail(false);
                }}
                className="font-normal  outline-none pt-0 pb-0 pl-4 pr-4 w-full m-0 focus:color-none"
                value={userMail}
                required
              />
            </div>
            {/* </div> */}
            {hasNoEmail && (
              <div className="text-red-400 space-x-1  flex  items-center ">
                <IoIosInformationCircle />{" "}
                <span className="text-xs">Email field Cant be Empty</span>
              </div>
            )}
            {invalidEmail && (
              <div className="text-red-400 flex space-x-1 items-center  ">
                <IoIosInformationCircle style={{ marginLeft: "0" }} />{" "}
                <span className="text-xs">Provide a valid email</span>
              </div>
            )}
            <div
              className={` border-style shadow  rounded  flex items-center h-10  mb-2 font-medium outline-1 outline  w-full mt-2 ${
                passwordEmpty || validPassword
                  ? " outline-red-400"
                  : "outline-[#d1d5db]"
              }`}
            >
              <input
                type={userPasswordShow ? "text" : "password"}
                placeholder="User Password"
                onChange={(e) => {
                  setUserPassword(e.target.value);
                  setPasswordEmpty(false);
                  setPasswordMatchError(false);
                }}
                className="font-normal  outline-none pt-0 pb-0 pl-4 pr-4 w-[90%] m-0"
                value={userPassword}
                required
              />
              {!userPasswordShow && (
                <div
                  className="input-inside-div mr-1"
                  onClick={() => {
                    setUserPasswordShow(true);
                  }}
                >
                  <MdOutlineVisibilityOff
                    style={{
                      fontSize: "23px",
                      color: "#d1d5db",
                    }}
                  />
                </div>
              )}
              {userPasswordShow && (
                <div
                  className="input-inside-div mr-1"
                  onClick={() => setUserPasswordShow(false)}
                >
                  <MdOutlineVisibility
                    style={{
                      fontSize: "23px",
                      color: "#d1d5db",
                    }}
                  />
                </div>
              )}
            </div>

            {passwordEmpty && (
              <div className="text-red-400 flex space-x-1 items-center  ">
                <IoIosInformationCircle style={{ marginLeft: "0" }} />{" "}
                <span className="text-xs">Password cannot be empty</span>
              </div>
            )}

            <div
              style={{ outlineColor: "#d1d5db" }}
              className={` border-style shadow  rounded  flex items-center h-10  mb-2 font-medium outline-1 outline  w-full mt-2 ${
                validPassword || confirmEmpty
                  ? " outline-red-400"
                  : "outline-[#d1d5db]"
              }`}
            >
              <input
                type={userPasswordConfirmShow ? "text" : "password"}
                placeholder="Confirm User Password"
                className="font-normal  outline-none pt-0 pb-0 pl-4 pr-4 w-[90%] m-0"
                onChange={(e) => {
                  setUserPasswordConfirm(e.target.value);
                  setConfirmEmpty(false);
                  setPasswordMatchError(false);
                }}
                value={userPasswordConfirm}
                required
              />
              {!userPasswordConfirmShow && (
                <div
                  className="input-inside-div mr-1"
                  onClick={() => setUserPasswordConfirmShow(true)}
                >
                  <MdOutlineVisibilityOff
                    style={{
                      fontSize: "23px",
                      color: "#d1d5db",
                    }}
                  />
                </div>
              )}
              {userPasswordConfirmShow && (
                <div
                  className="input-inside-div mr-1"
                  onClick={() => setUserPasswordConfirmShow(false)}
                >
                  <MdOutlineVisibility
                    style={{
                      fontSize: "23px",
                      color: "#d1d5db",
                    }}
                  />
                </div>
              )}
            </div>
            {validPassword && (
              <div className="flex space-x-1 items-center w-[90%] ml-auto mr-auto text-red-400 mb-1 text-center">
                <p className=" text-xs">
                  {" "}
                  Min <BoldSpan>8 characters</BoldSpan>, at least{" "}
                  <BoldSpan>1 number</BoldSpan>, at least{" "}
                  <BoldSpan>1 uppercase letter</BoldSpan> and at least{" "}
                  <BoldSpan>1 special character</BoldSpan>
                </p>
              </div>
            )}

            {/* confirm is empty */}
            {confirmEmpty && (
              <div className="text-red-400 flex space-x-1 items-center  mb-1">
                <IoIosInformationCircle style={{ marginLeft: "0" }} />{" "}
                <span className="text-xs">
                  Confirm password cannot be empty
                </span>
              </div>
            )}
            {passwordMatchError && (
              <div className="text-red-400 flex space-x-1 items-center  mb-1">
                <IoIosInformationCircle style={{ marginLeft: "0" }} />{" "}
                <span className="text-xs">Passwords don't match</span>
              </div>
            )}
          </div>
          <h3>{responseMsgUser}</h3>
          <div className="flex  mt-3 justify-between w-[full]  ">
            <div
              onClick={() => {
                handlemanageUserClose();
                resetError();
                setUserMail("");
                setUserPassword("");
                setUserPasswordConfirm("");
              }}
              className="w-[170px]"
            >
              <SubmitButton cancel={true} />
            </div>
            <div
              onClick={(e) => handleUserClick(e)}
              className=" w-[170px] "
              onKeyDown={(e) => {
                if (e.key === "Enter") handleUserClick(e);
              }}
            >
              <SubmitButton />
            </div>
          </div>
          {/* <button
            className="password-save-btn"
            onClick={(e) => handleUserClick(e)}
            disabled={isDiabledUser}
            style={
              isDiabledUser
                ? { backgroundColor: "gray", cursor: "default" }
                : {}
            }
          >
            Save Changes
          </button>
          <button className="password-cancel-btn" onClick={handlemanageUserClose}>
            Cancel
          </button> */}
        </form>
      </div>
    </Modal>
  );
};

export default AddEmployerModal;
